import { Link, useLocation } from "react-router-dom";
import { useStore } from "@/store/useStore";

export function Sidebar() {
  const location = useLocation();
  const sidebarOpen = useStore((s) => s.sidebarOpen);

  const navItems = [
    { path: "/dashboard", label: "Dashboard" },
    { path: "/opportunities", label: "Opportunities" },
    { path: "/watchlist", label: "Watchlist" },
    { path: "/alerts", label: "Alerts" },
    { path: "/operations", label: "Operations" },
    { path: "/reports", label: "Reports" },
    { path: "/billing", label: "Billing" },
    { path: "/settings", label: "Settings" },
  ];

  if (!sidebarOpen) return null;

  return (
    <aside className="w-64 min-h-screen bg-card border-r border-border">
      <nav className="p-4 space-y-1">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`block px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              location.pathname === item.path
                ? "bg-primary text-primary-foreground"
                : "text-foreground hover:bg-accent"
            }`}
          >
            {item.label}
          </Link>
        ))}
      </nav>
    </aside>
  );
}
